import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgEye(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.997 11.994.002.006-.002.006c-.014.056-.09.36-.48.896-.416.573-1.065 1.233-1.92 1.86C16.878 16.02 14.532 17 12 17c-2.533 0-4.879-.98-6.596-2.238-.856-.627-1.505-1.287-1.922-1.86-.39-.535-.465-.84-.479-.896L3.001 12l.002-.006c.014-.056.09-.36.48-.896.416-.573 1.065-1.233 1.92-1.86C7.122 7.98 9.468 7 12 7c2.533 0 4.879.98 6.596 2.238.856.627 1.505 1.287 1.922 1.86.39.535.465.84.479.896ZM23 12c0 2.333-4.925 7-11 7S1 14.333 1 12s4.925-7 11-7 11 4.667 11 7Zm-7 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.333-1.333a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);

var EyeSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { EyeSolid as default };
